import { render, staticRenderFns } from "./puSummary.vue?vue&type=template&id=56d2bcae"
import script from "./puSummary.vue?vue&type=script&lang=js"
export * from "./puSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports